import { createContext } from 'react';

export const AdminContext = createContext({ email: "", labId: "" });